import React from 'react';

import {SignIn} from 'presentation/pages';

export const MakeSignIn: React.FC = () => <SignIn />;
